import { render, staticRenderFns } from "./productDemandDetail.vue?vue&type=template&id=d67b5fda&scoped=true&"
import script from "./productDemandDetail.vue?vue&type=script&lang=js&"
export * from "./productDemandDetail.vue?vue&type=script&lang=js&"
import style0 from "./productDemandDetail.vue?vue&type=style&index=0&id=d67b5fda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67b5fda",
  null
  
)

export default component.exports